import { PropertiesTableProps } from '../../../../../shared/types'

export const ToolbarProperties: PropertiesTableProps = {}

export const ToolbarEvents: PropertiesTableProps = {}
